import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';

import TextInputs from 'src/components/inputs/TextInputs';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { MdDelete } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateExpenseData,
  resetExpenseData,
  setLoading,
  setStaffList,
  setExpenseTypes,
} from 'src/redux/slices/expenseSlice';
import './Expenses.css';
import { getHighlightedText } from 'src/utils/textUtils';

const paymentmode = ['Cash', 'Credit/Debit Card', 'Paytm', 'PhonePe', 'Gpay'];

const TrimData = (data) => {
  if (typeof data === 'string' && data.length > 20) {
    return data.substring(0, 20) + '...';
  }
  return data;
};

const Expenses = ({ data, getExpenses }) => {
  const dispatch = useDispatch();
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [hoveredItemId, setHoveredItemId] = useState(null);

  const { initialExpenseData, staffList, expenseTypes, loading , filters} = useSelector(
    (state) => state.expenses,
  );

  const {
    updateExpense,
    setShowMessage,
    deleteExpense,
    activeBranchId,
    getAllStaff,
    fetchAllExpenseType,
  } = useMain();

  // Original UI structure preserved below
  const handleUpdate = (item) => {
    setSelectedItemId(item._id);
    const { _id, ...rest } = item;
    dispatch(updateExpenseData(rest));
    setOpenDialogue(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateExpenseData({ [name]: value }));
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    dispatch(resetExpenseData());
  };

  const handleUpdateSubmit = async () => {
    try {
      dispatch(setLoading(true));
      const res = await updateExpense(
        selectedItemId,
        initialExpenseData,
        `?branchId=${activeBranchId}`,
      );

      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Expense has been updated',
          messageType: 'success',
        });
        // dispatch(
        //   setAllExpenses(
        //     data.map((item) =>
        //       item._id === selectedItemId ? { ...item, ...initialExpenseData } : item,
        //     ),
        //   ),
        // );
        getExpenses();
        getAllTypeOfExpense();
        fetchAllExpenseType(activeBranchId);
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something Went Wrong', messageType: 'error' });
    } finally {
      dispatch(setLoading(false));
      handleCloseDialogue();
    }
  };

  const handleDeleteField = (id) => {
    setSelectedItemId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      dispatch(setLoading(true));
      const res = await deleteExpense(selectedItemId, `?branchId=${activeBranchId}`);

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Expense has been deleted',
          messageType: 'success',
        });
        // dispatch(setAllExpenses(data.filter((item) => item._id !== selectedItemId)));
        getExpenses();
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Error occurred while deleting expense',
        messageType: 'error',
      });
    } finally {
      dispatch(setLoading(false));
      setOpenDeleteDialog(false);
      setSelectedItemId(null);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedItemId(null);
  };

  const getAllTypeOfExpense = async () => {
    try {
      const res = await fetchAllExpenseType(activeBranchId);
      if (res.statusCode === 200) {
        const types = [
          { label: 'Salary' },
          { label: 'Staff Advance' },
          ...res.data.map((t) => ({ label: t })),
          { label: 'Others' },
        ];
        dispatch(setExpenseTypes(types));
      }
    } catch (error) {}
  };

  useEffect(() => {
    const fetchStaff = async () => {
      if (activeBranchId) {
        try {
          const res = await getAllStaff(activeBranchId);
          if (res?.statusCode === 200) {
            dispatch(setStaffList(res.data));
          }
        } catch (error) {
          console.error('Error fetching staff:', error);
        }
      }
    };

    fetchStaff();
  }, [activeBranchId]);

  return (
    <Box sx={{ overflow: 'auto', width: '100%' }}>
      <table className="table-container">
        <thead className="table-thead" >
          <tr style={{ textAlign: 'center' }}>
            <th style={{ textAlign: 'center' }}>Date</th>
            <th style={{ textAlign: 'center' }}>Expense Type</th>
            <th style={{ textAlign: 'center' }}>Amount Paid</th>
            <th style={{ textAlign: 'center' }}>Payment Mode</th>
            <th style={{ textAlign: 'center' }}>Receipt Name</th>
            <th style={{ textAlign: 'center' }}>Description</th>
            <th style={{ textAlign: 'center' }}>Actions</th>
          </tr>
        </thead>
        <tbody className="table-tbody">
          {data.map((item) => {
            const originalDate = item?.date;
            let formattedExpenseDate = '';
            if (originalDate) {
              const [year, month, day] = originalDate.split('-');
              formattedExpenseDate = `${day}-${month}-${year}`;
            }
            return (
              <tr key={item._id}>
                <td style={{ textAlign: 'center' }}>{formattedExpenseDate}</td>
                <td style={{ textAlign: 'center' }}>{getHighlightedText(item?.typeOfExpense, filters?.search)}</td>
                <td style={{ textAlign: 'center' }}>{item?.amountPaid}</td>
                <td style={{ textAlign: 'center' }}>{getHighlightedText(item?.modeOfPayment, filters?.search)}</td>
                <td style={{ textAlign: 'center' }}>{getHighlightedText(item?.recipientName, filters?.search)}</td>
                <td style={{ position: 'relative', textAlign: 'center' }}>
                  <div
                    onMouseEnter={() => setHoveredItemId(item._id + '_description')}
                    onMouseLeave={() => setHoveredItemId(null)}
                    style={{ cursor: 'pointer' }}
                  >
                    {TrimData(item?.description)}
                    {hoveredItemId === item._id + '_description' && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          backgroundColor: '#dfe3f8',
                          border: '1px solid #ccc',
                          padding: '8px',
                          borderRadius: '5px',
                          zIndex: 5,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          whiteSpace: 'pre-wrap',
                          maxWidth: '300px',
                        }}
                      >
                        {item?.description}
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <IconButton
                    onClick={() => handleUpdate(item)}
                    color="secondary"
                    title="Update"
                  >
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteField(item._id)}
                    color="error"
                    title="Delete"
                  >
                    <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogContent>Are you sure you want to delete this Expense?</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>Expense Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update expense details.</DialogContentText>
          <Box style={{ marginTop: '10px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Date'}
                  name={'date'}
                  value={initialExpenseData?.date}
                  handleChange={handleChange}
                  type={'date'}
                  max={new Date().toISOString().split('T')[0]}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <SelectInputs
                  name={'typeOfExpense'}
                  value={initialExpenseData?.typeOfExpense}
                  title={'Type of Expense'}
                  handleChange={handleChange}
                  options={expenseTypes}
                  optionValue={'label'}
                  optionTitle={'label'}
                  required={false}
                />
              </Grid>
              {initialExpenseData.typeOfExpense === 'Others' ? (
                <Grid item xs={12} md={4}>
                  <TextInputs
                    title={'Others'}
                    name={'others'}
                    value={initialExpenseData?.others}
                    handleChange={handleChange}
                    type={'text'}
                    required={false}
                  />
                </Grid>
              ) : initialExpenseData.typeOfExpense === 'Staff Advance' ? (
                <Grid item xs={12} md={4}>
                  <SelectInputs
                    name={'staffId'}
                    value={initialExpenseData?.staffId}
                    title={'Staff'}
                    handleChange={handleChange}
                    options={staffList}
                    optionValue={'_id'}
                    optionTitle={'name'}
                    required={false}
                  />
                </Grid>
              ) : (
                ''
              )}
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Amount Paid'}
                  name={'amountPaid'}
                  value={initialExpenseData?.amountPaid}
                  placeholder={'0'}
                  handleChange={handleChange}
                  type={'number'}
                  min={'0'}
                  required={false}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
                  Payment Mode <ReqField />
                </div>
                <Select
                  name="modeOfPayment"
                  value={initialExpenseData?.modeOfPayment}
                  onChange={handleChange}
                  fullWidth
                >
                  {paymentmode?.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Receipt Name'}
                  name={'recipientName'}
                  value={initialExpenseData?.recipientName}
                  handleChange={handleChange}
                  type={'text'}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Description'}
                  name={'description'}
                  value={initialExpenseData?.description}
                  handleChange={handleChange}
                  type={'text'}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateSubmit}
                >
                  update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Expenses;

